import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { FilterSearchUrlAdapter } from 'common/module/filter/search/url/adapter';

export function FilterSearchUrlAdapterFactory(): FilterSearchUrlAdapter {
  return new FilterSearchUrlAdapter(WindowLocationService());
}
